import _property from 'lodash/property';

var archived = _property('archived');

var assetSubType = _property('assetSubType');

var assetType = _property('assetType');

var createdTime = _property('createdTime');

var dealerId = _property('dealerId');

var deleted = _property('deleted');

var fieldType = _property('fieldType');

var formEditable = _property('formEditable');

var hidden = _property('hidden');

var id = _property('id');

var key = _property('key');

var mandatory = _property('mandatory');

var name = _property('name');

var options = _property('options');

var order = _property('order');

var sfCanAddOptions = _property('sfCanAddOptions');

var sfCanEditMandatory = _property('sfCanEditMandatory');

var sfCanHide = _property('sfCanHide');

var sfCanRemoveDefaultOptions = _property('sfCanRemoveDefaultOptions');

var systemDefined = _property('systemDefined');

var userId = _property('userId');

var code = _property('extras.code.0');

var READER = {
  archived: archived,
  assetSubType: assetSubType,
  assetType: assetType,
  createdTime: createdTime,
  dealerId: dealerId,
  deleted: deleted,
  fieldType: fieldType,
  formEditable: formEditable,
  hidden: hidden,
  id: id,
  key: key,
  mandatory: mandatory,
  name: name,
  options: options,
  order: order,
  sfCanAddOptions: sfCanAddOptions,
  sfCanEditMandatory: sfCanEditMandatory,
  sfCanHide: sfCanHide,
  sfCanRemoveDefaultOptions: sfCanRemoveDefaultOptions,
  systemDefined: systemDefined,
  userId: userId,
  code: code
};
export default READER;